import { RegisteredComponent } from "@builder.io/sdk-react";
import { designTokens } from "../../designTokens";

export const tableCellBlockConfig: Omit<RegisteredComponent, "component"> = {
  name: "Table Cell",
  noWrap: true,
  image:
    "https://icons.veryicon.com/png/o/miscellaneous/cursoros-mouse-library/cell-7.png",
  shouldReceiveBuilderProps: {
    builderBlock: true,
    builderComponents: true,
    builderContext: true,
    builderLinkComponent: true,
  },
  canHaveChildren: true,
  requiresParent: {
    message: "This component must be nested within the Table Row component!",
    component: "Table Row",
  },
  defaultChildren: [
    {
      "@type": "@builder.io/sdk:Element",
      component: {
        name: "Text",
        options: {
          text: "Lorem ipsum",
        },
      },
      responsiveStyles: {
        large: {
          fontSize: designTokens.fontSize["Body - Small"],
          lineHeight: designTokens.lineHeight["Body - Small"],
          color: designTokens.colors["Body Primary"],
        },
      },
    },
  ],
  inputs: [
    {
      name: "headerType",
      type: "enum",
      localized: false,
      enum: [
        {
          label: "Column",
          value: "colHeader",
        },
        {
          label: "Row",
          value: "rowHeader",
        },
      ],
    },
    {
      name: "colspan",
      type: "number",
      localized: false,
      defaultValue: 1,
    },
    {
      name: "rowspan",
      type: "number",
      localized: false,
      defaultValue: 1,
    },
  ],
};
